<div class="folders-container flex flex-col gap-5">
  <div class="flex flex-row items-center justify-between">
    <div class="groups_title flex flex-row items-center justify-start">
      <ion-icon [id]="'tooltip-icon-folders'" class="tooltip-icon" color="light" src="assets/icon/info.svg"></ion-icon>
      <h2 class="raleway">Mis carpetas</h2>
      <ion-popover
        [trigger]="'tooltip-icon-folders'"
        class="info-popover"
        triggerAction="click"
        showBackdrop="true"
        animated="true"
      >
        <ng-template>
          <app-tooltip-info-folders></app-tooltip-info-folders>
        </ng-template>
      </ion-popover>
    </div>
    <ion-icon icon="assets/icon/cross.svg" (click)="closeFolders()"></ion-icon>
  </div>
  <div id="no-folders-section" class="flex flex-col gap-5">
    <div class="commentBox">
      <ion-label class="commentBox_label barlow">Añade un comentario</ion-label>
      <ion-textarea
        class="commentBox_textarea barlow"
        [autoGrow]="false"
        [counter]="true"
        maxlength="500"
        rows="3"
        placeholder="Escribe aquí tu comentario"
        debounce="1500"
        (ionFocus)="cartService.showConfirmCommentInfo($event)"
        (ionInput)="cartService.saveCart(this.cartService.cart)"
        [(ngModel)]="printProduct.product.printingGroup.comment"
      >
      </ion-textarea>
    </div>
    <hr style="margin-bottom: 20px" />
  </div>
  <div class="groups flex flex-col gap-5">
    <div class="groups_list flex flex-col gap-4" #groupsList [ngStyle]="{ height: scrollHeight + 'px' }">
      <ion-button class="create-group-button flex" (click)="reload()" color="tertiary" fill="solid">
        <ion-icon icon="assets/icon/add.svg"></ion-icon>
        <span class="barlow">Crear otra carpeta</span>
      </ion-button>
      <div class="flex flex-row flex-wrap justify-center gap-10">
        <app-print-group-folder-item
          *ngFor="let group of printGroupItems().reverse()"
          [currentPrintProduct]="printProduct"
          [group]="group"
          [isLoading]="isLoading"
          [isMobile]="true"
          (closeFoldersEvent)="closeFolders()"
        ></app-print-group-folder-item>
      </div>
    </div>
  </div>
</div>
